import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Sparkles, Heart, MessageCircle, User as UserIcon } from 'lucide-react';
import { useNotifications } from '../hooks/useNotifications';

const TenantNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasUnreadMessages, hasNewMatches } = useNotifications();

  const desktopNav = [
    { id: 'swipe', label: 'Discover', path: '/tenant/swipe', icon: Sparkles },
    { id: 'matches', label: 'Matches', path: '/tenant/matches', icon: Heart },
    { id: 'chat', label: 'Chats', path: '/tenant/chat', icon: MessageCircle },
    { id: 'profile', label: 'Profile', path: '/tenant/profile', icon: UserIcon },
  ];

  const isDesktopActive = (path: string) => {
    if (path === '/tenant/chat') {
      return location.pathname.startsWith('/tenant/chat');
    }
    if (path === '/tenant/matches') {
      return location.pathname.startsWith('/tenant/matches');
    }
    return location.pathname === path;
  };

  return (
    <div className="hidden md:flex items-center justify-between bg-white/80 backdrop-blur-md border border-gray-100 shadow-lg rounded-2xl px-4 py-3 sticky top-4 z-30">
      <div className="flex items-center gap-2">
        <img src="/logo.png" alt="RoomZa" className="w-10 h-10 rounded-xl" />
        <div className="flex flex-col">
          <span className="text-sm font-bold text-text-primary">RoomZa</span>
          <span className="text-xs text-text-secondary">Tenant</span>
        </div>
      </div>
      <div className="flex items-center gap-1">
        {desktopNav.map((item) => {
          const Icon = item.icon;
          const active = isDesktopActive(item.path);
          const hasNotification =
            (item.id === 'matches' && hasNewMatches) || (item.id === 'chat' && hasUnreadMessages);
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              aria-current={active ? 'page' : undefined}
              className={`relative flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-semibold transition-all duration-200 ${
                active
                  ? 'bg-primary-50 text-primary-300 border border-primary-100 shadow-sm'
                  : 'text-text-secondary hover:text-text-primary'
              }`}
            >
              <Icon className="w-4 h-4" aria-hidden="true" />
              {item.label}
              {hasNotification && <span className="sr-only">(new)</span>}
              {/* Notification Badge */}
              {item.id === 'matches' && hasNewMatches && (
                <div className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-gradient-to-r from-pink-500 to-rose-500 rounded-full border-2 border-white shadow-lg animate-pulse" />
              )}
              {item.id === 'chat' && hasUnreadMessages && (
                <div className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-gradient-to-r from-primary-300 to-primary-400 rounded-full border-2 border-white shadow-lg animate-pulse" />
              )}
            </button>
          );
        })}
      </div>
      <div className="w-32"></div> {/* Spacer for balance */}
    </div>
  );
};

export default TenantNav;
